import React, { useEffect, useState } from "react";
import logo from "../images/Maxicus_logo-white.png";
import logoMobile from "../images/shortlogo.png";
import { NavLink as Link, useLocation } from "react-router-dom";
import removeLocalStorageData from "../services/removeLocalStorageData";
import {
  User_Email_Tin_Upload_Rights,
  User_Email_Tin_Release_Rights,
  rights,
  DOCUMENT_RIGHTS,
  AI_SERVICE_RIGHTS,
} from "../umConfig";
import axios from "../services/axios";
import BASE from "../config";
import useSearchContext from "../hooks/useSearchContext";
import isConsultant from "../services/isConsultant";
import { usePermissions } from "../context/PermissionContext";
import useRole from "../hooks/useRole";

function Sidebar({ isMenuExpanded }) {
  const [access, setAccess] = useState();
  const [tab, setTab] = useState();
  const location = useLocation();
  const {
    hiredCount,
    talentpoolCount,
    rejectedCount,
    onHoldCount,
    newCount,
    inProcessCount,
    setHeaderFilterStatus,
    setCurrent,
    setHirePage,
    setHoldPage,
    setRejectPage,
    setPoolPage,
  } = useSearchContext();
  const queryParams = new URLSearchParams(location.search);
  const currentTab = queryParams.get("tab");
  const { permissions: sidebarPermissions, loading } = usePermissions();
  const role = useRole();
  const email = localStorage.getItem("user.email");
  const [isAmeyoActive, setIsAmeyoActive] = useState(true);

  useEffect(() => {
    axios
      .get("AmeyoServiceSettings", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setIsAmeyoActive(res.data?.AmeyoServiceSettings?.isActive ?? true);
      })
      .catch((err) => {
        console.error("Ameyo status check in sidebar failed:", err);
      });
  }, []);


  useEffect(() => {
    setTab(currentTab ? currentTab : null);
  }, [currentTab]);

  function loadContacts() {
    axios
      .get("manageTin/tinManagementRights/" + localStorage.getItem("user.id"), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        console.log(res.data.tinManagementRights);
        setAccess(res.data.tinManagementRights[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    if (isConsultant()) return;
    loadContacts();
  }, []);




  return (
    <>
      <ul
        className={`navbar-nav bg-gradient-primary sidebar toggled sidebar-dark accordion ${isMenuExpanded ? "expand_menu" : ""
          }`}
        id="accordionSidebar"
      >

        <div className="sidebar-brand d-flex align-items-center justify-content-center">
          <div className={`sidebar-brand-text ${isMenuExpanded ? "" : "mx-3"}`}>
            <img
              src={logo}
              className={`img-fluid logo-desktop ${isMenuExpanded ? "expand_menu" : ""
                }`}
              alt="Logo"
            />
            <img
              src={logoMobile}
              className={`img-fluid logo-mobile ${isMenuExpanded ? "expand_menu" : ""
                }`}
              alt="Logo"
            />
          </div>
        </div>

        <div
          id="loader"
          style={{
            margin: "0px",
            padding: "0px",
            position: "fixed",
            right: "0px",
            top: "0px",
            width: "100%",
            height: "100%",
            backgroundColor: "#666666",
            zIndex: "30001",
            opacity: ".8",
            filter: "alpha(opacity=70)",
            display: "none",
          }}
        >
          q
          <p
            style={{
              position: "absolute",
              color: "white",
              left: "50%",
              top: "50%",
              WebkitTransform: "translate(-50%, -50%)",
              transform: "translate(-50%, -50%)",
            }}
          >
            <img src="/img/ajax-loader.gif" alt="loader" />
            <span id="loaderText">
              <b>Loading...</b>
            </span>
          </p>
        </div>

        <hr className="sidebar-divider" />
        <div
          id="loader"
          style={{
            margin: "0px",
            padding: "0px",
            position: "fixed",
            right: "0px",
            top: "0px",
            width: "100%",
            height: "100%",
            backgroundColor: "#666666",
            zIndex: "30001",
            opacity: ".8",
            filter: "alpha(opacity=70)",
            display: "none",
          }}
        >
          q
          <p
            style={{
              position: "absolute",
              color: "white",
              left: "50%",
              top: "50%",
              WebkitTransform: "translate(-50%, -50%)",
              transform: "translate(-50%, -50%)",
            }}
          >
            <img src="/img/ajax-loader.gif" alt="img" />{" "}
            <span id="loaderText">
              <b>Loading...</b>
            </span>
          </p>
        </div>
        {localStorage.getItem("user.role") === "client" ? (
          <li className="nav-item ">
            <Link
              activeClassName="nav-link nav-link-active"
              className="nav-link"
              to="/clientdashboard"
              onClick={() => {
                localStorage.setItem("form_ids", "");
                removeLocalStorageData();
              }}
              exact
            >
              <i className="fas fa-fw fa-user"></i>
              <span>Client round</span>
            </Link>
          </li>
        ) : (
          <div>
            {isConsultant() ? (
              <ul>
                <li className="nav-item ">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/consultantdashboard"
                    onClick={() => {
                      localStorage.setItem("form_ids", "");
                      removeLocalStorageData();
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-globe"></i>
                    <span>Dashboard</span>
                  </Link>
                </li>
                {/* // qrcode link */}
                <li className="nav-item ">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/qrcode"
                    onClick={() => {
                      localStorage.setItem("form_ids", "");
                      removeLocalStorageData();
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-qrcode"></i>
                    <span>Scanner Code</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/newcandidates"
                    onClick={() => {
                      localStorage.setItem("form_ids", "");
                      removeLocalStorageData();
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-group"></i>
                    <span className="mb-0">New Candidates</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/selectedcandidates"
                    onClick={() => {
                      localStorage.setItem("form_ids", "");
                      removeLocalStorageData();
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-group"></i>
                    <span className="mb-0">Selected Candidates</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/joinedcandidates"
                    onClick={() => {
                      localStorage.setItem("form_ids", "");
                      removeLocalStorageData();
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-user-plus"></i>
                    <span className="mb-0">Joined Candidates</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/pendingcandidates"
                    onClick={() => {
                      localStorage.setItem("form_ids", "");
                      removeLocalStorageData();
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-clock-o"></i>
                    <span className="mb-0">Pending Candidates</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/rejectedcandidates"
                    onClick={() => {
                      localStorage.setItem("form_ids", "");
                      removeLocalStorageData();
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-user-times"></i>
                    <span className="mb-0">Rejected Candidates</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/inactivecandidate"
                    onClick={() => {
                      localStorage.setItem("form_ids", "");
                      removeLocalStorageData();
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-user-times"></i>
                    <span className="mb-0">Inactive Candidates</span>
                  </Link>
                </li>
              </ul>
            ) : (
              //qrcode link
              <div>
                {/* <li className="nav-item ">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/home"
 exact
 >
 <i className="fab fa-fw fa-dashcube"></i>
 <span>Dashboard</span>
 </Link>
 </li> */}
                <div className="sidebar-heading">Candidates</div>

                {/* <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/candidates/new"
 exact
 >
 <i className="fas fa-fw fa-certificate "></i>
 <span>New Applications</span>
 </Link>
 </li> */}

                {/* <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/screening"
 exact
 >
 <i className="fas fa-fw fa-address-book"></i>
 <span>Screening Board</span>
 </Link>
 </li> */}

                <li className="nav-item">
                  <Link
                    className={`nav-link ${tab === "Application_Received"
                      ? "nav-link nav-link-active"
                      : ""
                      }`}
                    to="/candidate_dashboard?tab=Application_Received"
                    onClick={() => {
                      setCurrent(1);
                      setHeaderFilterStatus("Application_Received");
                      localStorage.setItem(
                        "headerFilterStatus",
                        "Application_Received",
                      );
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-globe"></i>
                    <span>
                      All Applications{" "}
                      <strong>
                        {newCount > 0 || inProcessCount > 0
                          ? `(${newCount + inProcessCount})`
                          : ""}
                      </strong>
                    </span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${tab === "On Hold" ? "nav-link nav-link-active" : ""
                      }`}
                    to="/candidate_dashboard?tab=On Hold"
                    onClick={() => {
                      setHeaderFilterStatus("On Hold");
                      setHoldPage(1);
                      localStorage.setItem("headerFilterStatus", "On Hold");
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-globe"></i>
                    <span>
                      On Hold{" "}
                      <strong>
                        {onHoldCount > 0 ? `(${onHoldCount})` : ""}
                      </strong>
                    </span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${tab === "Hired" ? "nav-link nav-link-active" : ""
                      }`}
                    to="/candidate_dashboard?tab=Hired"
                    onClick={() => {
                      setHirePage(1);
                      setHeaderFilterStatus("Hired");
                      localStorage.setItem("headerFilterStatus", "Hired");
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-globe"></i>
                    <span>
                      Hired{" "}
                      <strong>{hiredCount > 0 ? `(${hiredCount})` : ""}</strong>
                    </span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${tab === "Rejected" ? "nav-link nav-link-active" : ""
                      }`}
                    to="/candidate_dashboard?tab=Rejected"
                    onClick={() => {
                      setRejectPage(1);
                      setHeaderFilterStatus("Rejected");
                      localStorage.setItem("headerFilterStatus", "Rejected");
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-globe"></i>
                    <span>
                      Rejected{" "}
                      <strong>
                        {rejectedCount > 0 ? `(${rejectedCount})` : ""}
                      </strong>
                    </span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${tab === "TalentPool" ? "nav-link nav-link-active" : ""
                      }`}
                    to="/candidate_dashboard?tab=TalentPool"
                    onClick={() => {
                      setPoolPage(1);
                      setHeaderFilterStatus("TalentPool");
                      localStorage.setItem("headerFilterStatus", "TalentPool");
                    }}
                    exact
                  >
                    <i className="fas fa-fw fa-globe"></i>
                    <span>
                      Talent Pool{" "}
                      <strong>
                        {talentpoolCount > 0 ? `(${talentpoolCount})` : ""}
                      </strong>
                    </span>
                  </Link>
                </li>
                {isAmeyoActive && sidebarPermissions.canViewManagerDashboard && (
                  <li className="nav-item">
                    <Link
                      activeClassName="nav-link nav-link-active"
                      className="nav-link"
                      to="/manager/dashboard"
                      exact
                    >
                      <i className="fas fa-fw fa-globe"></i>
                      <span>Manager Dashboard</span>
                    </Link>
                  </li>
                )}
                {/* 
 <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/candidates/assigned"
 exact
 >
 <i className="fas fa-fw fa-comments"></i>
 <span>Your Interviews</span>
 </Link>
 </li> */}
                {/* 
 <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/candidates/archive"
 exact
 >
 <i className="fas fa-fw fa-archive"></i>
 <span>Archive</span>
 </Link>
 </li>
 
 <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/candidates/rejected"
 exact
 >
 <i className="fas fa-fw fa-exclamation-triangle"></i>
 <span>Rejected</span>
 </Link>
 </li> */}

                <hr className="sidebar-divider" />

                {/* <div className="sidebar-heading">Reports</div> */}
                {/* 
 <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/reports/l1"
 exact
 onClick={() => {
 localStorage.setItem("form_ids", "");
 removeLocalStorageData();
 }}
 >
 <span>L1 Interview</span>
 </Link>
 </li>
 
 <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/reports/l2"
 onClick={() => {
 localStorage.setItem("form_ids", "");
 removeLocalStorageData();
 }}
 exact
 >
 <span>L2 Interview</span>
 </Link>
 </li>
 
 <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/reports/l3"
 onClick={() => {
 localStorage.setItem("form_ids", "");
 removeLocalStorageData();
 }}
 exact
 >
 <span>L3 Interview</span>
 </Link>
 </li> */}

                {
                  (sidebarPermissions.canViewApplications ||
                    sidebarPermissions.canViewBulkUpload ||
                    sidebarPermissions.canViewVoiceBot ||
                    sidebarPermissions.canViewForm ||
                    sidebarPermissions.canViewFormBuilder) && (
                    <div className="sidebar-heading">Applications</div>
                  )
                }


                {sidebarPermissions.canViewBulkUpload && (
                  <li className="nav-item">
                    <Link
                      activeClassName="nav-link nav-link-active"
                      className="nav-link"
                      to="/bulkUpload"
                      exact
                    >
                      <i className="fas fa-fw fa-upload"></i>
                      <span>Bulk Upload</span>
                    </Link>
                  </li>
                )}
                {sidebarPermissions.canViewVoiceBot && (
                  <li className="nav-item">
                    <Link
                      activeClassName="nav-link nav-link-active"
                      className="nav-link"
                      to="/voice-bot-upload"
                      exact
                    >
                      <i className="fas fa-fw fa-upload"></i>
                      <span>Voice Bot Upload</span>
                    </Link>
                  </li>
                )}
                {/*} )}*/}
                {sidebarPermissions.canViewFormBuilder && (
                  <li className="nav-item">
                    <Link
                      activeClassName="nav-link nav-link-active"
                      className="nav-link"
                      to="/build/forms"
                      exact
                    >
                      <i className="fas fa-fw fa-braille"></i>
                      <span>Form Builder</span>
                    </Link>
                  </li>
                )}

                {loading && (
                  <div style={{ padding: '4px 0' }}>
                    <style>{`
                      @keyframes sidebarShimmer {
                        0% { background-position: 200% 0; }
                        100% { background-position: -200% 0; }
                      }
                    `}</style>
                    {[
                      { heading: '55%', items: [['70%'], ['50%']] },
                      { heading: '50%', items: [['75%'], ['60%'], ['55%']] },
                      { heading: '45%', items: [['65%'], ['55%']] },
                      { heading: '40%', items: [['70%'], ['80%'], ['50%'], ['60%']] },
                      { heading: '55%', items: [['45%'], ['55%'], ['65%']] },
                    ].map((section, si) => (
                      <div key={si}>
                        <hr className="sidebar-divider" />
                        <div style={{
                          height: 8, width: section.heading, borderRadius: 3,
                          background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
                          backgroundSize: '200% 100%', animation: `sidebarShimmer 1.5s ease-in-out infinite`,
                          animationDelay: `${si * 0.2}s`, margin: '12px 16px 8px 16px', textTransform: 'uppercase',
                        }} />
                        {section.items.map((item, ii) => (
                          <div key={ii} style={{ display: 'flex', alignItems: 'center', padding: '9px 16px', gap: 10 }}>
                            <div style={{
                              width: 14, height: 14, borderRadius: 3, flexShrink: 0,
                              background: 'linear-gradient(90deg, #d5d5d5 25%, #ebebeb 50%, #d5d5d5 75%)',
                              backgroundSize: '200% 100%', animation: `sidebarShimmer 1.5s ease-in-out infinite`,
                              animationDelay: `${si * 0.2 + ii * 0.1}s`,
                            }} />
                            <div style={{
                              height: 12, width: item[0], borderRadius: 4,
                              background: 'linear-gradient(90deg, #d5d5d5 25%, #ebebeb 50%, #d5d5d5 75%)',
                              backgroundSize: '200% 100%', animation: `sidebarShimmer 1.5s ease-in-out infinite`,
                              animationDelay: `${si * 0.2 + ii * 0.1}s`,
                            }} />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
                {sidebarPermissions.canViewForm && (
                  <li className="nav-item">
                    <Link
                      activeClassName="nav-link nav-link-active"
                      className="nav-link"
                      to="/form-templates"
                      exact
                    >
                      <i className="fas fa-fw fa-database"></i>
                      <span>Forms</span>
                    </Link>
                  </li>
                )
                }

                {/* <li className="nav-item">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/documents"
                    exact
                  >
                    <i className="fas fa-fw fa-book"></i>
                    <span>Joining Forms</span>
                  </Link>
                </li> */}
                {/* <li className="nav-item">
                  {localStorage.getItem("user.role") === "admin" && (
                    <Link
                      activeClassName="nav-link nav-link-active"
                      className="nav-link"
                      to="/question/bank"
                      exact
                    >
                      <i className="fas fa-fw fa-question"></i>
                      <span>Question Bank</span>
                    </Link>
                  )}
                </li> */}
                {/* <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/documents/view"
 exact
 >
 <i className="fas fa-fw fa-book"></i>
 <span>Documents</span>
 </Link>
 </li> */}
                {/* <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/chatbot/service"
 exact
 >
 <i className="fas fa-fw fa-book"></i>
 <span>Chatbot Service</span>
 </Link>
 </li> */}

                <div>
                  <hr className="sidebar-divider" />
                  {(sidebarPermissions.canViewTrf || sidebarPermissions.canViewAssignTrf) && (
                    <div className="sidebar-heading">Trf Management</div>
                  )}
                  {sidebarPermissions.canViewTrf && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/trf"
                        exact
                      >
                        <i className="fas fa-fw fa-id-card"></i>
                        <span>Talent Requisition Form</span>
                      </Link>
                    </li>
                  )}
                  {sidebarPermissions.canViewAssignTrf && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/trf/assign"
                        exact
                      >
                        <i className="fas fa-fw fa-id-card"></i>
                        <span>Assign TRF</span>
                      </Link>
                    </li>
                  )}
                </div>


                <>
                  {(sidebarPermissions.canViewVersant ||
                    sidebarPermissions.canViewTinAccess ||
                    sidebarPermissions.canViewTinReport) && (
                      <div className="sidebar-heading">Tin Management</div>
                    )}
                  {sidebarPermissions.canViewVersant && (
                    <li className="nav-item">

                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/versant-configuration"
                        exact
                      >
                        <i className="fas fa-fw fa-id-card"></i>
                        <span>Versant Configuration</span>
                      </Link>

                    </li>
                  )}
                  {access?.upload && (
                    <>
                      {/* <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/tin/upload"
                            exact
                          >
                            <i className="fas fa-fw fa-upload"></i>
                            <span>Tin Upload</span>
                          </Link>
                        </li> */}

                      {/* <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/tin/uploaded/report"
                            exact
                          >
                            <i className="fas fa-fw fa-upload"></i>
                            <span>Tin Uploaded Report</span>
                          </Link>
                        </li> */}
                    </>
                  )}
                  {/* {access?.release && (
                      <li className="nav-item">
                        <Link
                          activeClassName="nav-link nav-link-active"
                          className="nav-link"
                          to="/tin/release"
                          exact
                        >
                          <i className="fas fa-fw fa-upload"></i>
                          <span>Tin Release</span>
                        </Link>
                      </li>
                    )} */}
                  {sidebarPermissions.canViewTinReport && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/tin/usage/report"
                        exact
                      >
                        <i className="fas fa-fw fa-upload"></i>
                        <span>Tin Usage</span>
                      </Link>
                    </li>
                  )}
                  {/* <hr className="sidebar-divider" /> */}
                </>


                {/* {sidebarPermissions.canViewTinAccess && (
                  <li className="nav-item">
                    <Link
                      activeClassName="nav-link nav-link-active"
                      className="nav-link"
                      to="/tin/rights"
                      exact
                    >
                      <i className="fas fa-fw fa-upload"></i>
                      <span>Tin Access Management</span>
                    </Link>
                  </li>
                )} */}
                <hr className="sidebar-divider" />
                {/* <hr className="sidebar-divider" />

 <div className="sidebar-heading">Process</div>

 <li className="nav-item">
 <Link
 activeClassName="nav-link nav-link-active"
 className="nav-link"
 to="/process"
 exact
 >
 <i className="fas fa-fw fa-spinner"></i>
 <span>Process</span>
 </Link>
 </li> */}
                {(sidebarPermissions.canViewDocuments ||
                  sidebarPermissions.canViewCreateDocument ||
                  sidebarPermissions.canViewCentralHRAudit ||
                  sidebarPermissions.canViewSiteHRAudit) && (
                    <div>
                      <div className="sidebar-heading">Documents</div>
                      {sidebarPermissions.canViewDocuments && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/documents/candidates"
                            exact
                          >
                            <i className="fas fa-fw fa-list"></i>
                            <span>Documents</span>
                          </Link>
                        </li>
                      )}

                      {sidebarPermissions.canViewCreateDocument && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/digital/document/create"
                            exact
                          >
                            <i className="fas fa-fw fa-list"></i>
                            <span>Create Document</span>
                          </Link>
                        </li>
                      )}
                      {sidebarPermissions.canViewCentralHRAudit && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/audit/central-hr"
                            exact
                          >
                            <i className="fas fa-fw fa-list"></i>
                            <span>Document Audit</span>
                          </Link>
                        </li>
                      )}
                      {sidebarPermissions.canViewSiteHRAudit && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/audit/site-hr"
                            exact
                          >
                            <i className="fas fa-fw fa-list"></i>
                            <span>Document Audit</span>
                          </Link>
                        </li>
                      )}
                    </div>
                  )}
                {(sidebarPermissions.canViewAdminDashboard || sidebarPermissions.canViewInterviewDashboard) && (
                  <div>
                    <div className="sidebar-heading">Analytics</div>
                    {BASE.DASHBOARD_IDS.map((dashboard) => {
                      let hasPermission = false;

                      if (dashboard.role === 'admin') {
                        hasPermission = sidebarPermissions.canViewAdminDashboard;
                      } else if (dashboard.role === 'interviewer') {
                        hasPermission = sidebarPermissions.canViewInterviewDashboard;
                      }

                      if (dashboard.label && hasPermission) {
                        return (
                          <li className="nav-item">
                            <Link
                              activeClassName="nav-link nav-link-active"
                              className="nav-link"
                              to={`/analytics/${dashboard.key}`}
                              exact
                            >
                              <i className="fas fa-fw fa-list"></i>
                              <span>{dashboard.label}</span>
                            </Link>
                          </li>
                        );
                      }
                    })}
                  </div>
                )}

                {(sidebarPermissions.canViewCompetencySetup ||
                  sidebarPermissions.canViewClientMapping ||
                  sidebarPermissions.canViewConsultantMapping ||
                  sidebarPermissions.canViewCallStatus ||
                  sidebarPermissions.canViewRuleEngine ||
                  sidebarPermissions.canViewAmeyoConfiguration ||
                  sidebarPermissions.canViewInterviewStatus) && (
                    <div>
                      <div className="sidebar-heading">Admin</div>
                      {sidebarPermissions.canViewCompetencySetup && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/competency/configuration"
                            exact
                          >
                            <i className="fas fa-fw fa-list"></i>
                            <span>Competency Setup</span>
                          </Link>
                        </li>
                      )}

                      {isAmeyoActive && sidebarPermissions.canViewRuleEngine && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/rule-engine"
                            exact
                          >
                            <i className="fas fa-fw fa-list"></i>
                            <span>Rule Engine</span>
                          </Link>
                        </li>
                      )}
                      {isAmeyoActive && sidebarPermissions.canViewAmeyoConfiguration && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/ameyo/configuration"
                            exact
                          >
                            <i className="fas fa-fw fa-cog"></i>
                            <span>Ameyo Configuration</span>
                          </Link>
                        </li>
                      )}
                      {sidebarPermissions.canViewClientMapping && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/client/mapping"
                            exact
                          >
                            <i className="fas fa-fw fa-user"></i>
                            <span>Client Mapping</span>
                          </Link>
                        </li>
                      )}
                      {/* Consultant mapping */}
                      {sidebarPermissions.canViewConsultantMapping && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/consultant/mapping"
                            exact
                          >
                            <i className="fas fa-fw fa-user"></i>
                            <span>Consultant Mapping</span>
                          </Link>
                        </li>
                      )}
                      {sidebarPermissions.canViewCallStatus && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/call/status/mapping"
                            exact
                          >
                            <i className="fas fa-fw fa-phone"></i>
                            <span>Call Status Mapping</span>
                          </Link>
                        </li>
                      )}
                      {sidebarPermissions.canViewInterviewStatus && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/add/interviewStatus"
                            exact
                          >
                            <i className="fas fa-fw fa-list"></i>
                            <span>Status Mapping</span>
                          </Link>
                        </li>
                      )}
                    </div>
                  )}

                <div>
                  {(sidebarPermissions.canViewDocumentReport ||
                    sidebarPermissions.canViewApplicationReport ||
                    sidebarPermissions.canViewAuditReport ||
                    sidebarPermissions.canViewAiReport ||
                    sidebarPermissions.canViewOtpLogs ||
                    sidebarPermissions.canViewInterviewLogs ||
                    sidebarPermissions.canViewFeedbackReport ||
                    sidebarPermissions.canViewLoginReport ||
                    sidebarPermissions.canViewDistributedTrf) && (
                      <div className="sidebar-heading">Reports</div>
                    )}
                  {sidebarPermissions.canViewDocumentReport && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/document_report"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>Document Reports</span>
                      </Link>
                    </li>
                  )}
                  {sidebarPermissions.canViewApplicationReport && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/all_applications_report"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>All Applications Report</span>
                      </Link>
                    </li>
                  )}
                  {sidebarPermissions.canViewAuditReport && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/audit-report"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>Audit Report</span>
                      </Link>
                    </li>
                  )}
                  {sidebarPermissions.canViewAiReport && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/logs/ocr"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>AI Report</span>
                      </Link>
                    </li>
                  )}
                  {sidebarPermissions.canViewOtpLogs && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/logs/status"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>OTP Logs Status</span>
                      </Link>
                    </li>
                  )}
                  {sidebarPermissions.canViewInterviewLogs && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/logs/interview"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>Interview Logs</span>
                      </Link>
                    </li>
                  )}
                  {sidebarPermissions.canViewFeedbackReport && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/feedback/report"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>Feedback Report</span>
                      </Link>
                    </li>
                  )}
                  {/* <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/inactive/candidates"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>Inactive Candidates</span>
                      </Link>
                    </li> */}
                  {/* <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/active_inactive/candidates"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>Active | Inactive Candidates</span>
                      </Link>
                    </li> */}
                  {sidebarPermissions.canViewLoginReport && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/login/report"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>Login Report</span>
                      </Link>
                    </li>
                  )}
                  {/* <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/trf/report"
                        exact>
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>Trf Report</span>
                      </Link>
                    </li> */}
                  {sidebarPermissions.canViewDistributedTrf && (
                    <li className="nav-item">
                      <Link
                        activeClassName="nav-link nav-link-active"
                        className="nav-link"
                        to="/assigntrf/report"
                        exact
                      >
                        <i className="fas fa-fw fa-exclamation-triangle"></i>
                        <span>Distributed Trf Report</span>
                      </Link>
                    </li>
                  )}
                </div>

                {/* <div className="sidebar-heading">Queries</div>

                <li className="nav-item">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/queries/unsolved"
                    exact
                  >
                    <i className="fas fa-fw fa-exclamation-triangle"></i>
                    <span>Unsolved</span>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    activeClassName="nav-link nav-link-active"
                    className="nav-link"
                    to="/queries"
                    exact
                  >
                    <i className="fas fa-fw fa-question-circle"></i>
                    <span>All Queries</span>
                  </Link>
                </li> */}

                <div>
                  {(sidebarPermissions.canViewAdmin ||
                    sidebarPermissions.canManageUsers ||
                    // sidebarPermissions.canViewRegister ||
                    sidebarPermissions.canViewLogs ||
                    sidebarPermissions.canViewApiLogs ||
                    sidebarPermissions.canViewAiService ||
                    sidebarPermissions.canViewAmeyoService ||
                    sidebarPermissions.canViewServiceSettings ||
                    sidebarPermissions.canViewSettings) && (
                    <div>
                      <div className="sidebar-heading">Administration</div>

                      {sidebarPermissions.canViewAdmin && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/admin"
                            exact
                          >
                            <i className="fas fa-fw fa-user-shield"></i>
                            <span>Roles & Permissions</span>
                          </Link>
                        </li>
                      )}

                      {sidebarPermissions.canManageUsers && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/users"
                            exact
                          >
                            <i className="fas fa-fw fa-users"></i>
                            <span>Users</span>
                          </Link>
                        </li>
                      )}

                      {/* {sidebarPermissions.canViewRegister && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/register"
                            exact
                          >
                            <i className="fas fa-fw fa-book"></i>
                            <span>Register</span>
                          </Link>
                        </li>
                      )} */}

                      {sidebarPermissions.canViewLogs && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/logs"
                            exact
                          >
                            <i className="fas fa-fw fa-history"></i>
                            <span>Logs</span>
                          </Link>
                        </li>
                      )}

                      {sidebarPermissions.canViewApiLogs && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/api_logs"
                            exact
                          >
                            <i className="fas fa-fw fa-history"></i>
                            <span>API Logs</span>
                          </Link>
                        </li>
                      )}

                      {sidebarPermissions.canViewAiService && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/ai/settings"
                            exact
                          >
                            <i className="fas fa-fw fa-wrench"></i>
                            <span>AI Service</span>
                          </Link>
                        </li>
                      )}

                      {sidebarPermissions.canViewAmeyoService && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/ameyo/settings"
                            exact
                          >
                            <i className="fas fa-fw fa-wrench"></i>
                            <span>Ameyo Service</span>
                          </Link>
                        </li>
                      )}

                      {sidebarPermissions.canViewServiceSettings && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/service/settings"
                            exact
                          >
                            <i className="fas fa-fw fa-wrench"></i>
                            <span>Service Settings</span>
                          </Link>
                        </li>
                      )}


                      {sidebarPermissions.canViewSettings && (
                        <li className="nav-item">
                          <Link
                            activeClassName="nav-link nav-link-active"
                            className="nav-link"
                            to="/settings/admin"
                            exact
                          >
                            <i className="fas fa-fw fa-wrench"></i>
                            <span>Settings</span>
                          </Link>
                        </li>
                      )}
                    </div>
                  )}

                  <div className="mt-2">
                    {(sidebarPermissions.canViewGenerateExcel || sidebarPermissions.canViewQr) && (
                      <div className="sidebar-heading">Dev Tools</div>
                    )}
                    {sidebarPermissions.canViewGenerateExcel && (
                      <li className="nav-item">
                        <Link
                          activeClassName="nav-link nav-link-active"
                          className="nav-link"
                          to="/generate-excel"
                          exact
                        >
                          <i className="fas fa-fw fa-upload"></i>
                          <span>Generate XLSX</span>
                        </Link>
                      </li>
                    )}
                    {sidebarPermissions.canViewQr && (
                      <li className="nav-item">
                        <Link
                          activeClassName="nav-link nav-link-active"
                          className="nav-link"
                          to="/generate-qrCode"
                          exact
                        >
                          <i className="fas fa-fw fa-upload"></i>
                          <span>Generate QrCode</span>
                        </Link>
                      </li>

                    )}
                  </div>

                </div>
              </div>
            )}
          </div>
        )}
      </ul>
    </>
  );
}

export default Sidebar;
